<template>
  <el-row>
    <el-row>
      <el-col :span="2">
        <h6 style="text-align: left">会员卡: </h6>
      </el-col>
      <el-col :span="2" :offset="20" v-if="this.$store.state.CurrentUser != 'reader'">
        <el-button size="mini" type="primary" style="margin-bottom: 5px" @click="toggleActivate"><i class="el-icon-plus"></i></el-button>
      </el-col>
    </el-row>

    <el-row style="margin: 10px 0px; border: 1px solid #eee; border-radius: 5px; background-color: #eee" v-if="showActivate">
      <el-form ref="form" :model="cardForm" label-width="90px" style="text-align: left">
        <el-form-item label="套餐类型">
          <el-radio-group v-model="cardForm.type">
            <el-radio label="1">399套餐</el-radio>
            <el-radio label="2">499套餐</el-radio>
            <el-radio label="3">599套餐</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="免费次数">
          <el-row>
            <el-col :span="10">
              <el-slider v-model="cardForm.free" :max="20" :min="0" input-size="small"></el-slider>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="使用次数">
          <el-row>
            <el-col :span="10">
              <el-slider v-model="cardForm.used" :max="20" :min="0" input-size="small"></el-slider>
            </el-col>
            <el-col :span="2" :offset="10">
              <el-button type="primary" @click="activateVip"><i class="el-icon-sunny"></i> 激活</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-row>

    <el-table
      :data="cards"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="卡号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="provider"
        label="成交页面商家">
      </el-table-column>
      <el-table-column
        prop="types"
        label="卡类型">
        <template slot-scope="scope">
          {{ scope.row.types == '1' ? '399套餐' : (scope.row.types == '2' ? '499套餐' : '599套餐') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="free"
        label="免费次数">
        <template slot-scope="scope">
          {{scope.row.free}}
          <el-button @click="updateCardFreeTimes(scope.row.id)" style="margin-left:1em" type="danger" icon="el-icon-edit" circle size="mini"></el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="used"
        label="使用次数">
      </el-table-column>
      <el-table-column
        prop="et"
        label="购买时间">
        <template slot-scope="scope">
          {{ scope.row.et.substring(0, 10) }}
        </template>
      </el-table-column>
    </el-table>

    <h6 style="text-align: left; margin-top: 20px">保养记录: </h6>
    <el-table
      :data="maintains"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="payId"
        label="支付订单号">
      </el-table-column>
      <el-table-column
        prop="garage"
        label="修理厂">
        <template slot-scope="scope">
          <router-link :to="{path: '/provider/details', query: {id: scope.row.garage}}">{{scope.row.garage}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="oil"
        label="用油类型">
      </el-table-column>
      <el-table-column
        prop="volume"
        label="用油升数">
        <template slot-scope="scope">
          {{ scope.row.volume }} 升
        </template>
      </el-table-column>

      <el-table-column
        prop="surcharge"
        label="额外支付">
        <template slot-scope="scope">
          {{ scope.row.surcharge / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="总支付">
        <template slot-scope="scope">
          {{ scope.row.amount / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          {{ scope.row.status == '0' ? '保养中' : (scope.row.status == '1' ? '核销完成' : '核销失败') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="hourFee"
        label="工时费">
        <template slot-scope="scope">
          {{ scope.row.hourFee / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="et"
        label="发生时间">
        <template slot-scope="scope">
          {{ scope.row.et.substring(0, 10) }}
        </template>
      </el-table-column>

      <el-table-column label="#">
        <template slot-scope="scope">
          <el-button v-if="currentUser != 'reader' && scope.row.status == '0'"
                     @click="forceMaintainFailed(scope.row.id)" type="danger"><i class="el-icon-circle-close"></i> 强制失败</el-button>
          <div v-else>#</div>
        </template>
      </el-table-column>

    </el-table>
  </el-row>
</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "VIPInfo",
  props: {
    customerId: String,
    cards: Array,
    maintains: Array,
  },
  data() {
    return {
      showActivate: false,
      cardForm: {
        free: 1,
        used: 0,
        type: "1",
      },
      currentUser: this.$store.state.CurrentUser
    }
  },

  methods: {
    forceMaintainFailed(id) {
      const params = {
        maintainId: id
      }

      api.userMaintainForceFail(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('操作失败: ' + result.error.message);
        } else {
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      })
    },

    toggleActivate() {
      this.showActivate = !this.showActivate
    },

    activateVip() {
      const params = {
        customerId: this.customerId,
        free: this.cardForm.free,
        type: this.cardForm.type,
        used: this.cardForm.used
      }

      api.activateVip(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.$message.success('激活成功')
          this.toggleActivate()
          this.$emit('refresh')
        }
      })
    },

    async updateCardFreeTimes(cardId) {
      let times = 0;
      try {
        const res = await this.$prompt("请输入免费次数，范围是[0, 20]", "修改免费次数", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^\d{1,2}$/,
          inputErrorMessage: "请输出正确的免费次数"
        })
        times = Number(res.value);
        if (!Number.isSafeInteger(times) || times < 0 || times > 20) {
          this.$message.error("无效输入，范围是[0, 20]");
          return;
        }
      }catch (e) {
        console.info('用户取消输入', e)
        return;
      }

      const params = {cardId, times}
      api.updateCardFreeTimes(params).then(res => {
        let result = res.data;
        if (result.error) {
          this.$message.error('后台服务出错');
        }else {
          this.$message.success('修改成功')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/users/vip/VIPInfo.vue